import { usePathname } from 'next/navigation'

const useIsNativeBlogPage = () => {
  const pathName = usePathname()
  return pathName?.includes('/native-blog') ?? false
}

export default useIsNativeBlogPage
